import { queryClient } from "@/app/providers/QueryProvider";
import { router } from "@/app/router";
import { useAuthStore } from "@/auth/store";
import { apiClient } from "./client";

export function setupApiClient() {
  apiClient.setOnUnauthorized(() => {
    useAuthStore.getState().clearAuth();
    queryClient.clear();
    void router.navigate({ to: "/login" });
  });
}
